import { render, staticRenderFns } from "./FKomoditiTypeImportDialog.vue?vue&type=template&id=4da447b8&scoped=true"
import script from "./FKomoditiTypeImportDialog.vue?vue&type=script&lang=js"
export * from "./FKomoditiTypeImportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da447b8",
  null
  
)

export default component.exports